export default __webpack_public_path__ + "static/media/picture03.1c746acd.GIF";